"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.kansaProgressReducer = exports.kansaProgressActions = exports.TYPES = exports.PERMISSION_KEY = exports.CONTENTS = void 0;
var _CodeConsts = require("01_core/constants/CodeConsts");
var _reduxActions = require("redux-actions");
var _Consts = require("../common/consts/Consts");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
// アクションタイプの接頭辞
const PREFIX = _Consts.CONSTS.COMMON_ACTION_PREFIX + 'Progress';

// アクションタイプ
const TYPES = exports.TYPES = {
  // メイン
  GO_MAIN: PREFIX + 'GoMain',
  // 状況先へ遷移
  GO_STS_PAGE: PREFIX + 'GoStsPage',
  // 検索結果設定
  SET_SEARCH_RESULT: PREFIX + 'SetProgressResult',
  // 検索条件変更
  CHANGE_CONDITION: PREFIX + 'ChangeCondition',
  // 共有検索条件設定
  APPLY_SHARE_CONDITION: PREFIX + 'ApplyShareCondtion',
  // 全て表示切替
  CHANGE_SHOW_ALL: PREFIX + 'ChangeShowAll',
  // ページングリセット
  RESET_PAGING: PREFIX + 'ResetPaging',
  // ページ変更
  CHANGE_PAGE: PREFIX + 'ChangePage',
  // １ページの表示件数を変更
  CHANGE_VIEW_NUM: PREFIX + 'ChangeViewNum',
  // 年度選択変更
  CHANGE_NENDO: PREFIX + 'ChangeNendo',
  // 業務内容変更
  CHANGE_GYOMUCD: PREFIX + 'ChangeGyomuCd',
  // 初期値を返却
  INIT_NENDO: PREFIX + 'initNendo',
  // 利用許可
  SET_PERMISSION_ALLUSE: PREFIX + 'SetPermissionAlluse',
  SET_PERMISSION_LIMITUSE: PREFIX + 'SetPermissionLimituse',
  // 全状態を初期状態にする
  CLEAR: PREFIX + 'Clear',
  // スクロール位置を変更
  CHANGE_SCROLL_TOP: PREFIX + 'ChangeScrollTop'
};

// 利用許可属性
const PERMISSION_KEY = exports.PERMISSION_KEY = {
  ALLUSEPERMISSION: 'allusepermission',
  // システム管理者
  LIMITEDUSEPERMISSION: 'limitedusepermission' // 事務局
};

// 表示コンテンツ(画面遷移先の子画面)
const CONTENTS = exports.CONTENTS = {
  MAIN: 'main',
  ANSWER_REGISTOR: 'registor',
  ANSWER_DISPLAY: 'display',
  MAKE_REGISTOR: 'registor',
  MAKE_DISPLAY: 'display',
  MAKE_OLD_DETAIL: 'shitekiOldDetail',
  SHITEKI_ENTRY: 'shitekiEntry',
  SHITEKI_DETAIL: 'shitekiDetail',
  SHITEKI_OLD_DETAIL: 'shitekiOldDetail',
  HYOKA_REGISTOR: 'registor',
  HYOKA_DISPLAY: 'display',
  PROGRESS_TO_ANSWER_REFER: 'progressToAnswerRefer',
  // 監査進捗状況：監査回答表示
  PROGRESS_TO_ANSWER_REGISTER: 'progressToAnswerRegister',
  // 監査進捗状況：監査回答登録
  PROGRESS_TO_RESULT_REFER: 'progressToResultRefer',
  // 監査進捗状況：監査結果表示
  PROGRESS_TO_RESULT_REFER_OLD: 'progressToResultReferOld',
  // 監査進捗状況：監査結果表示（詳細版）
  PROGRESS_TO_RESULT_REGISTER: 'progressToResultRegister',
  // 監査進捗状況：監査結果登録
  PROGRESS_TO_RESULT_UPDATE: 'progressToResultUpdate',
  // 監査進捗状況：監査結果更新
  PROGRESS_TO_SHITEKI_REFER: 'progressToShitekiRefer',
  // 監査進捗状況：指摘事項改善・実績表示
  PROGRESS_TO_SHITEKI_REFER_OLD: 'progressToShitekiReferOld',
  // 監査進捗状況：指摘事項改善・実績表示（詳細版）
  PROGRESS_TO_SHITEKI_REGISTER: 'progressToShitekiRegister',
  // 監査進捗状況：指摘事項改善・実績登録
  PROGRESS_TO_HYOKA_REFER: 'progressToHyokaRefer',
  // 監査進捗状況：被監査部門責任者評価表示
  PROGRESS_TO_HYOKA_REGISTER: 'progressToHyokaRegister' // 監査進捗状況：被監査部門責任者評価登録
};

// 初期状態
const INIT_STATE = {
  dispContent: CONTENTS.MAIN,
  searchResult: [],
  conditions: {
    gyomuCdAvail: _CodeConsts.CODE.AUTH_GYOMU_CD.CODE_3,
    // 権限制御業務内容コード
    gyomuCd: _CodeConsts.CODE.KANSA_GYOMU_CD.CODE_1,
    //業務内容
    kansaTgtNendo: null,
    //監査対象年度
    kansaTgtJigyoId: '',
    //監査対象事業Id
    kansaTgtJigyoNm: '',
    //監査対象事業名
    kansaTgtNendoNm: '',
    //監査対象年度ラベル
    kansaThemeNm: '',
    //監査テーマ
    kansaKaishaCd: '',
    //監査部門 会社コード
    kansaBumonCd: '',
    //監査部門 組織コード
    kansaBumonNm: '',
    //監査部門名
    hikansaKaishaCd: '',
    //被監査部門 会社コード
    hikansaBumonCd: '',
    //被監査部門 組織コード
    hikansaBumonNm: '',
    //被監査部門名

    tantoOnlyFlg: false,
    //担当の監査対象事業のみ表示
    kansaSts: _CodeConsts.CODE.KANSA_STS.CODE_0,
    //監査状況
    kaitoSts: _CodeConsts.CODE.KANSA_ANS_STS.CODE_0,
    //監査回答状況
    makeSts: _CodeConsts.CODE.KANSA_RSLT_STS.CODE_0,
    //監査結果作成状況
    planSts: _CodeConsts.CODE.KANSA_KZPLN_STS.CODE_4,
    //指摘事項改善計画状況
    evalSts: _CodeConsts.CODE.KANSA_HYOKA_STS.CODE_0,
    //被監査部門責任者評価評価状況
    permissionAlluse: {
      [PERMISSION_KEY.ALLUSEPERMISSION]: false // システム管理者
    },
    permissionlimituse: {
      [PERMISSION_KEY.LIMITEDUSEPERMISSION]: false // 事務局
    }
  },
  showAll: false,
  //全て表示
  gyomuCd: '',
  // 選択中の年度
  selectNendo: '',
  selectThemeNm: '',
  search: false,
  // 検索条件表示時の検索実行有無 true:検索する、false:検索しない
  kansaInfo: {
    gyomuNaiyo: '',
    kansaTgtNendo: '',
    kansaTgtJigyoId: ''
  },
  paging: {
    viewNum: 50,
    //表示件数
    currentPage: 0 //現在表示中ページ番号
  },
  scrollTop: {
    index: 0,
    scrollY: 0,
    noSticky: false
  }
};
// アクション定義
const kansaProgressActions = exports.kansaProgressActions = (0, _reduxActions.createActions)({
  [TYPES.GO_MAIN]: function () {
    return {
      search: arguments.length <= 0 ? undefined : arguments[0]
    };
  },
  [TYPES.GO_STS_PAGE]: function () {
    return {
      selectDispContent: arguments.length <= 0 ? undefined : arguments[0],
      selectKansaTgtNendo: arguments.length <= 1 ? undefined : arguments[1],
      selectKansaTgtJigyoId: arguments.length <= 2 ? undefined : arguments[2]
    };
  },
  [TYPES.CHANGE_PAGE]: function () {
    return {
      currentPage: arguments.length <= 0 ? undefined : arguments[0]
    };
  },
  [TYPES.CHANGE_SHOW_ALL]: function () {
    return {
      showAll: arguments.length <= 0 ? undefined : arguments[0]
    };
  },
  [TYPES.SET_SEARCH_RESULT]: function () {
    return {
      searchResult: arguments.length <= 0 ? undefined : arguments[0]
    };
  },
  [TYPES.CHANGE_CONDITION]: function () {
    return {
      key: arguments.length <= 0 ? undefined : arguments[0],
      value: arguments.length <= 1 ? undefined : arguments[1]
    };
  },
  [TYPES.APPLY_SHARE_CONDITION]: function () {
    return {
      conditions: arguments.length <= 0 ? undefined : arguments[0]
    };
  },
  // １ページの表示件数を変更
  [TYPES.CHANGE_VIEW_NUM]: function () {
    return {
      viewNum: arguments.length <= 0 ? undefined : arguments[0]
    };
  },
  // 年度選択変更
  [TYPES.CHANGE_NENDO]: function () {
    return {
      selectNendo: arguments.length <= 0 ? undefined : arguments[0],
      selectThemeNm: arguments.length <= 1 ? undefined : arguments[1]
    };
  },
  // 業務内容変更
  [TYPES.CHANGE_GYOMUCD]: function () {
    return {
      gyomuCd: arguments.length <= 0 ? undefined : arguments[0]
    };
  },
  // 初期値を返却
  [TYPES.INIT_NENDO]: function () {
    return {
      selectNendo: arguments.length <= 0 ? undefined : arguments[0],
      selectThemeNm: arguments.length <= 1 ? undefined : arguments[1]
    };
  },
  [TYPES.SET_PERMISSION_ALLUSE]: function () {
    return {
      key: arguments.length <= 0 ? undefined : arguments[0],
      flg: arguments.length <= 1 ? undefined : arguments[1]
    };
  },
  [TYPES.SET_PERMISSION_LIMITUSE]: function () {
    return {
      key: arguments.length <= 0 ? undefined : arguments[0],
      flg: arguments.length <= 1 ? undefined : arguments[1]
    };
  },
  [TYPES.CHANGE_SCROLL_TOP]: function () {
    return {
      scrollTop: arguments.length <= 0 ? undefined : arguments[0]
    };
  }
}, TYPES.RESET_PAGING, TYPES.CLEAR);

// Reducer定義
const kansaProgressReducer = exports.kansaProgressReducer = (0, _reduxActions.handleActions)({
  [TYPES.GO_MAIN]: (state, action) => _objectSpread(_objectSpread({}, state), {}, {
    dispContent: CONTENTS.MAIN,
    search: action.payload.search
  }),
  [TYPES.GO_STS_PAGE]: (state, action) => {
    const {
      selectDispContent,
      selectKansaTgtNendo,
      selectKansaTgtJigyoId
    } = action.payload;
    return _objectSpread(_objectSpread({}, state), {}, {
      dispContent: selectDispContent,
      kansaInfo: {
        gyomuNaiyo: state.conditions.gyomuCd,
        kansaTgtNendo: selectKansaTgtNendo,
        kansaTgtJigyoId: selectKansaTgtJigyoId
      }
    });
  },
  [TYPES.CHANGE_PAGE]: (state, action) => _objectSpread(_objectSpread({}, state), {}, {
    paging: _objectSpread(_objectSpread({}, state.paging), {}, {
      currentPage: action.payload.currentPage
    })
  }),
  [TYPES.SET_SEARCH_RESULT]: (state, action) => _objectSpread(_objectSpread({}, state), {}, {
    searchResult: action.payload.searchResult,
    paging: _objectSpread({}, INIT_STATE.paging),
    search: false
  }),
  [TYPES.CHANGE_CONDITION]: (state, action) => _objectSpread(_objectSpread({}, state), {}, {
    conditions: _objectSpread(_objectSpread({}, state.conditions), {}, {
      [action.payload.key]: action.payload.value
    })
  }),
  [TYPES.APPLY_SHARE_CONDITION]: (state, action) => _objectSpread(_objectSpread({}, state), {}, {
    conditions: _objectSpread(_objectSpread({}, state.conditions), action.payload.conditions)
  }),
  [TYPES.CHANGE_SHOW_ALL]: (state, action) => {
    let newSearchResult = JSON.parse(JSON.stringify(state.searchResult)).map(item => {
      return item;
    });
    return _objectSpread(_objectSpread({}, state), {}, {
      searchResult: newSearchResult,
      showAll: action.payload.showAll
    });
  },
  [TYPES.RESET_PAGING]: state => _objectSpread(_objectSpread({}, state), {}, {
    paging: _objectSpread({}, INIT_STATE.paging)
  }),
  [TYPES.CHANGE_VIEW_NUM]: (state, action) => _objectSpread(_objectSpread({}, state), {}, {
    paging: _objectSpread(_objectSpread({}, state.paging), {}, {
      currentPage: 0,
      viewNum: action.payload.viewNum
    })
  }),
  [TYPES.SET_PERMISSION_ALLUSE]: (state, action) => _objectSpread(_objectSpread({}, state), {}, {
    permissionAlluse: {
      [action.payload.key]: action.payload.flg
    }
  }),
  [TYPES.SET_PERMISSION_LIMITUSE]: (state, action) => _objectSpread(_objectSpread({}, state), {}, {
    permissionLimituse: {
      [action.payload.key]: action.payload.flg
    }
  }),
  [TYPES.CHANGE_GYOMUCD]: (state, action) => {
    const {
      gyomuCd
    } = action.payload;
    return _objectSpread(_objectSpread({}, state), {}, {
      gyomuCd: gyomuCd,
      conditions: _objectSpread(_objectSpread({}, state.conditions), {}, {
        gyomuCd: gyomuCd
      })
    });
  },
  // 年度選択変更
  [TYPES.CHANGE_NENDO]: (state, action) => {
    const {
      selectNendo,
      selectThemeNm
    } = action.payload;
    return _objectSpread(_objectSpread({}, state), {}, {
      selectNendo: selectNendo,
      selectThemeNm: selectThemeNm,
      conditions: _objectSpread(_objectSpread({}, state.conditions), {}, {
        kansaTgtNendo: selectNendo,
        kansaThemeNm: selectThemeNm
      })
    });
  },
  // 初期値を返却
  [TYPES.INIT_NENDO]: (state, action) => {
    const {
      selectNendo,
      selectThemeNm
    } = action.payload;
    return _objectSpread(_objectSpread({}, state), {}, {
      selectNendo: selectNendo,
      selectThemeNm: selectThemeNm,
      conditions: _objectSpread(_objectSpread({}, state.conditions), {}, {
        kansaTgtNendo: selectNendo,
        kansaThemeNm: selectThemeNm
      })
    });
  },
  // スクロール位置を変更
  [TYPES.CHANGE_SCROLL_TOP]: (state, action) => _objectSpread(_objectSpread({}, state), {}, {
    scrollTop: action.payload.scrollTop
  }),
  //クリア
  [TYPES.CLEAR]: () => _objectSpread({}, INIT_STATE)
}, INIT_STATE);